module.exports = __webpack_public_path__ + "img/Semi-detached_House.bbf79787.svg";